import React from "react";
import { Redirect } from "react-router-dom";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const VibesListConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: ["/vibes/:id?"],
    component: React.lazy(() => import("./vibes-list")),
  },
  {
    path: "/vibes",
    component: () => {
      return <Redirect to="/vibes" />;
    },
  },
];
